// extracted by mini-css-extract-plugin
export default {"submenu":"golfamore_css_module__M6NLbw3f"};